<template>
  <div>
   <el-form ref="form" :model="ruleForm" label-width="100px">
         <el-row :gutter="20">
          <el-col :offset="1" :span="10"><div class="grid-content bg-purple">
            <el-form-item label="里程桩号编号" prop="LCZHBH">
              <el-input :disabled="!edit" v-model="ruleForm.LCZHBH"  ></el-input>
            </el-form-item>
            </div></el-col>
          <el-col :span="10" ><div class="grid-content bg-purple">
             <el-form-item label="里程桩号名称" prop="LCZHMC">
              <el-input :disabled="!edit" v-model="ruleForm.LCZHMC"  ></el-input>
            </el-form-item>
            </div></el-col>
        </el-row>
       <el-row :gutter="20">
          <el-col :offset="1" :span="10"><div class="grid-content bg-purple">
            <el-form-item label="组织结构" prop="SSZZJG">
              <el-select :disabled="!edit" v-model="ruleForm.SSZZJG"  :value="mineStatusValue" multiple collapse-tags @change="selectChange">
                <el-option :value="mineStatusValue" style="height: auto">
                  <el-tree :data="data" show-checkbox node-key="id" ref="tree" highlight-current :props="defaultProps" @check-change="handleCheckChange"></el-tree>
              </el-option>
              </el-select>
            </el-form-item>
            </div></el-col>
          <el-col :span="10" ><div class="grid-content bg-purple">
             <el-form-item label="公里数起点" prop="GLS">
              <el-input :disabled="!edit" v-model="ruleForm.GLS"  ></el-input>
            </el-form-item>
            </div></el-col>
        </el-row>
         <el-row :gutter="20">
          <el-col :offset="1" :span="10"><div class="grid-content bg-purple">
            <el-form-item label="距离数起点" prop="JLS">
                 <el-input :disabled="!edit" v-model="ruleForm.JLS"  ></el-input>
            </el-form-item>
            </div></el-col>
          <el-col :span="10" ><div class="grid-content bg-purple">
             <el-form-item label="公里数止点" prop="GLS2">
                  <el-input :disabled="!edit" v-model="ruleForm.GLS2"  ></el-input>
            </el-form-item>
            </div></el-col>
        </el-row>
         <el-row :gutter="20">
          <el-col :offset="1" :span="19"><div class="grid-content bg-purple">
            <el-form-item label="距离数止点" prop="JLS2">
              <el-input :disabled="!edit" v-model="ruleForm.JLS2"  ></el-input>
            </el-form-item>
            </div></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :offset="1" :span="10"><div class="grid-content bg-purple">
            <el-form-item label="Y坐标" prop="YZB">
                 <el-input :disabled="!edit" v-model="ruleForm.YZB"  ></el-input>
            </el-form-item>
            </div></el-col>
          <el-col :span="10" ><div class="grid-content bg-purple">
             <el-form-item label="X坐标" prop="XZB">
                 <el-input :disabled="!edit" v-model="ruleForm.XZB"  ></el-input>
            </el-form-item>
            </div></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :offset="1" :span="10"><div class="grid-content bg-purple">
            <el-form-item label="Y坐标2" prop="YZB2">
                 <el-input :disabled="!edit" v-model="ruleForm.YZB2"  ></el-input>
            </el-form-item>
            </div></el-col>
          <el-col :span="10" ><div class="grid-content bg-purple">
             <el-form-item label="X坐标2" prop="XZB2">
                <el-input :disabled="!edit" v-model="ruleForm.XZB2"  ></el-input>
            </el-form-item>
            </div></el-col>
        </el-row>

         <el-row :gutter="20">
          <el-col :offset="1" :span="11"><div class="grid-content bg-purple">
            <el-form-item label="是否重点关注" prop="SFZDGZ">
                    <el-radio-group v-model="ruleForm.SFZDGZ" :disabled="!edit">
                      <el-radio :label="1">启用</el-radio>
                      <el-radio :label="0">不启用</el-radio>
                    </el-radio-group>
            </el-form-item>
            </div></el-col>
         </el-row>
  
         <el-row :gutter="20">
          <el-col :offset="1" :span="11"><div class="grid-content bg-purple">
            <el-form-item label="是否启用" prop="QYBZ">
                    <el-radio-group v-model="ruleForm.QYBZ" :disabled="!edit">
                      <el-radio :label="1">启用</el-radio>
                      <el-radio :label="0">不启用</el-radio>
                    </el-radio-group>
            </el-form-item>
            </div></el-col>
          <el-col :span="11" ><div class="grid-content bg-purple">
             <el-form-item label="是否删除" prop="SCBZ">
                <div>
                <el-radio-group v-model="ruleForm.SCBZ" :disabled="!edit">
                      <el-radio :label="0">正常</el-radio>
                      <el-radio :label="1">删除</el-radio>
                    </el-radio-group>
              </div>           
             </el-form-item>
            </div></el-col>
        </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapState } from "vuex"
export default {
  computed: {
     ...mapState({
       zzjg: state => state.tab.zzjg
     })
  },
  props: {
    ruleForm:Object,
    edit: Boolean
  },
  data(){
    return{
      mineStatus: "",
      mineStatusValue: "",
      data:[],
      defaultProps: {
        children: "children",
        label: "label",
        SSZZJG:"SSZZJG"
      },
        value: ''
    }
  },
  mounted(){
    this.mineStatusValue = this.ruleForm.SSZZJGMC
  },
  created(){
    this.data = this.zzjg
  },
   methods: {
    //select框值改变时候触发的事件
    selectChange(e){
      var arrNew = [];
        var dataLength = this.mineStatusValue.length;
        var eleng = e.length;
        for(let i = 0; i< dataLength ;i++){
          for(let j = 0; j < eleng; j++){
            if(e[j] === this.mineStatusValue[i].label){
              arrNew.push(this.mineStatusValue[i])
            }
          }
        }
        this.$refs.tree.setCheckedNodes(arrNew);//设置勾选的值
    },
    handleCheckChange(data,checked, node) {
        if(checked){
        this.$refs.tree.setCheckedNodes([data]);
        }
        let res = this.$refs.tree.getCheckedNodes(true, true); //这里两个true，1. 是否只是叶子节点 2. 是否包含半选节点（就是使得选择的时候不包含父节点）
        let arrLabel = [];
        let arr = [];
        res.forEach(item => { 
          arrLabel.push(item.label)
          arr.push(item.ZZJGBH)
        });
        this.mineStatusValue = arr
        this.$emit("setZzjgBh",arr[0])
        this.ruleForm.SSZZJG = arrLabel
      }
  }
};
</script>

<style lang="scss" scoped>
span{
  padding-left: 10px
}
</style>
